import type { RolMultiTenant } from '@/types/roles'

/** Subset de UsuarioConMembresia necesario para el check de delegación cross-cliente. */
export interface UsuarioAsignable {
  id: string
  email: string
  nombre: string | null
  rol: RolMultiTenant | null
}

/** Campos del form de tarea relevantes para el check (opcionales, como en TareaFormValues). */
export interface DatosDelegacion {
  cliente_id?: string | null
  asignado_a?: string | null
}

/**
 * ORR-202: decide si hay que verificar el acceso del asignado al cliente antes de
 * delegar la tarea. Devuelve `false` (sin chequeo) cuando:
 * - no hay cliente o no hay asignado,
 * - el asignado es el propio usuario actual (auto-asignación),
 * - el asignado no se encuentra en la lista,
 * - el asignado es owner/admin (ve todos los clientes; el scoping por responsable no aplica).
 *
 * Si devuelve `true`, el caller debe consultar los responsables del cliente y, si el
 * asignado no está entre ellos, pedir confirmación para otorgarle acceso (opción a).
 */
export function requiereChequeoAccesoCliente(
  values: DatosDelegacion,
  asignado: UsuarioAsignable | undefined,
  emailUsuarioActual: string | null,
): boolean {
  if (!values.cliente_id || !values.asignado_a) return false
  if (values.asignado_a === emailUsuarioActual) return false
  if (!asignado) return false
  if (asignado.rol === 'owner' || asignado.rol === 'admin') return false
  return true
}
